import React from 'react';

const PlayIcon = ({
  width = 40,
  height = 40,
  color = 'var(--ca-theme-palette-colors-controlButtonColor, #4B1C46)',
  bg = 'white',
  className = '',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <circle cx="20" cy="20" r="19.1667" fill={bg} stroke={color} strokeWidth="1.66667" />
    <path
      d="M18.2523 15.043C17.8362 14.7782 17.2917 15.0771 17.2917 15.5703V24.4296C17.2917 24.9228 17.8362 25.2216 18.2523 24.9569L25.2132 20.5272C25.5991 20.2816 25.5991 19.7183 25.2132 19.4727L18.2523 15.043Z"
      fill={color}
    />
  </svg>
);

export default PlayIcon;
